export function gtag(..._args: Object[]) {
  window['dataLayer']?.push(arguments);
}
